export default __webpack_public_path__ + "static/media/AQTimePro-Logo.35325b14.svg";